
if ($('.js-start-tests-open').length){

    $('.js-start-tests-open').click(function(){
        let parent = $(this).parent()

        $('.js-start-tests-c').each(function(){
            if (this !== parent[0]){
                $(this).removeClass('open')
                $(this).find('.js-start-tests-opened').hide()
            }
        })
        

        if (parent.hasClass('open')){
            closeAccesibilityC(parent)
        } else {
            parent.find('.js-start-tests-opened').slideToggle()
            parent.toggleClass('open')
        }

    })
    $(document).on("click", function(event) {
        let accesibilityC = $('.js-start-tests-c')
        if (!accesibilityC.length) return

        if (accesibilityC.hasClass("open") && !$(event.target).closest(".js-start-tests-c").length) {
            closeAccesibilityC(accesibilityC) 
        }
    });
    function closeAccesibilityC(accesibilityC){
        accesibilityC.find('.js-start-tests-opened').slideUp()
        setTimeout(function(){
            accesibilityC.removeClass('open')
        }, 400)
    }

}